import React, { useEffect, useRef, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Input,
  Label,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { Link, useParams } from "react-router-dom";
import { connect } from "react-redux";
import * as url from "../../helpers/url_helper";
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import { setBreadcrumbItems } from "../../store/actions";
import { toast } from "react-toastify";
const UsersEdit = () => {
  const breadcrumbItems = [
    { title: "VUF", link: "#" },
    { title: "User List", link: "#" },
    { title: "User Edit", link: "#" },
  ];
  const [SelectedCategory, setSelectCategory] = useState({});
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [SelectedDepartment, setSelectDepartment] = useState({});
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [SelectedDesignation, setSelectDesignation] = useState({});
  const [designationOptions, setDesignationOptions] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const flatpickrRef = useRef(null);
  const { Type, id } = useParams();
  const [userDetails, setUserDetails] = useState({
    resident_type: "",
  });
  const [selectedCity, setSelectedCity] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [areas, setAreas] = useState([]);
  const [errors, setErrors] = useState({});
  const [area, setarea] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showArea, setShowArea] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);
  const [LoadingText, setLoadingText] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [OtherType, setOtherType] = useState(true);
  const [locationType, setLocationType] = useState({});
  const [phoneCode, setPhoneCode] = useState([]);
  const [countryDropdown, setCountryDropDown] = useState(false);
  const [postcodeDropdown, setPostCodeDropdown] = useState(false);
  const [countryList, setCountryCodeList] = useState([]);
  const [countryCode, setCountryCode] = useState([]);
  const [selectedService, setSelectService] = useState("");
  const [SelectedService, setSelectedService] = useState("");
  const [SelectedDiscount, setSelectedDiscount] = useState("");
  const [showBenefitsModal, setShowBenefitsModal] = useState(false);
  const [selectedBenefitId, setSelectedBenefitId] = useState(null);
  const [serviceOptions, setServiceOptions] = useState([]);
  const [benefitsCategoryOptions, setBenefitsCategoryOptions] = useState([]);
  const [OtherTypeStyle, setOtherTypeStyle] = useState({
    backgroundColor: "#f3f4f6",
    color: "#6b7280",
    cursor: "not-allowed",
  });
  /* form end*/

  const ProfessionObj = [
    { value: "State Gov. Job", label: "State Gov. Job" },
    { value: "Central Gov. Job", label: "Central Gov. Job" },
    { value: "Doctor", label: "Doctor" },
    { value: "Engineer", label: "Engineer" },
    { value: "Advocate", label: "Advocate" },
    { value: "Business", label: "Business" },
    { value: "Retired", label: "Retired" },
    { value: "Teacher", label: "Teacher" },
    { value: "Farmer", label: "Farmer" },
    { value: "Homemaker(Housewife)", label: "Homemaker(Housewife)" },
    { value: "Others", label: "Others" },
  ];
  const ChangeLocation = async (location) => {
    if (location === "Indian Resident") {
      setCountryDropDown(false);
      setPostCodeDropdown(false);
      setPhoneCode("91");
    } else {
      setPhoneCode("");
      countryListWithCode();
      setPostCodeDropdown(true);
      setCountryDropDown(true);
    }
  };

  function countryListWithCode(location) {
    const urlPath = `auth/CountryList`;
    setLoadingText(true);
    setDisabled(true);
    fetch(`${url.VUF_APP_API}${urlPath}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status) {
          const list = data.response;
          const options = list
            // .filter((country) => country.country_name !== "India")
            .map((country) => ({
              label: country.country_name,
              value: country.country_name,
              pCode: country.phonecode,
              code: country.country_code,
            }));
          setCountryCodeList(options);
        }
      })
      .catch((error) => {
        console.error("Pincode fetch error:", error);
        toast.warn("Something went wrong, please try again later.");
      });
  }

  const getClientTimeZone = () =>
    Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";

  const getDatePartsInTimeZone = (date, timeZone) => {
    const parts = new Intl.DateTimeFormat("en-CA", {
      timeZone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).formatToParts(date);

    return {
      year: Number(parts.find((p) => p.type === "year")?.value || 0),
      month: Number(parts.find((p) => p.type === "month")?.value || 0),
      day: Number(parts.find((p) => p.type === "day")?.value || 0),
    };
  };

  const clientTimeZone = getClientTimeZone();

  const normalizeDob = (dob) => {
    if (!dob) return null;

    // Keep Flatpickr value as Date so existing DOB is visible in edit mode.
    if (dob instanceof Date && !isNaN(dob.getTime())) {
      return new Date(dob.getFullYear(), dob.getMonth(), dob.getDate());
    }

    const rawDob =
      typeof dob === "object" && dob !== null
        ? dob.$date || dob.date || ""
        : dob;

    if (typeof rawDob === "string") {
      const datePart = rawDob.slice(0, 10);
      const match = datePart.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (match) {
        const year = Number(match[1]);
        const month = Number(match[2]) - 1;
        const day = Number(match[3]);
        const localDate = new Date(year, month, day);
        if (!isNaN(localDate.getTime())) return localDate;
      }
    }

    const parsedDate = new Date(rawDob);
    if (isNaN(parsedDate.getTime())) return null;

    const { year, month, day } = getDatePartsInTimeZone(
      parsedDate,
      clientTimeZone,
    );

    const normalizedDate = `${year}-${String(month).padStart(2, "0")}-${String(
      day,
    ).padStart(2, "0")}`;
    if (normalizedDate === "1970-01-01") return null;

    return new Date(year, month - 1, day);
  };

  const formatDobForApi = (dob) => {
    const normalizedDob = normalizeDob(dob);
    if (!normalizedDob) return null;

    const { year, month, day } = getDatePartsInTimeZone(
      normalizedDob,
      clientTimeZone,
    );
    return `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
  };
  const handleUpdateDetails = async (id) => {
    setLoading(true);
    try {
      let urlPath = `updateUserDetails/${id}`;
      const payload = {
        firstName: userDetails.Fname,
        lastName: userDetails.lname,
        mobileno: userDetails.mobile,
        email: userDetails.email,
        dob: formatDobForApi(userDetails.dob),
        bloodgroup: userDetails.bloodGroup,
        pincode: userDetails.pincode,
        street_address: userDetails.street_address,
        resident_type: userDetails.resident_type,
        gender: userDetails.gender,
      };
      if (locationType == "NRI") {
        Object.assign(payload, {
          country: userDetails.country,
          state: userDetails.state,
          area: userDetails.city,
          countryCode: userDetails.countryCode,
        });
      } else {
        Object.assign(payload, {
          area: userDetails.area,
          profession: userDetails.profession,
          otherProfession: userDetails.otherProfession,
          address: userDetails.city,
          country: "India",
          state: userDetails.state,
          district: userDetails.district,
        });
      }

      const response = await fetch(url.AUTH_URL + urlPath, {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (result.status) {
        setShowArea(false);
        toast.success("User Details Updated Successfully!");
        setLoading(false);
      }
    } catch (error) {
      console.error("Update error:", error);
      toast.warn("Something went wrong!");
    }
  };

  const handleUserDesignationDelete = async (e) => {
    e.preventDefault();
    setShowDeleteModal(false);

    try {
      const response = await fetch(
        url.AUTH_URL + `deleteUserDesignation/${selectedId}`,
        {
          method: "DELETE",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        },
      );

      const result = await response.json();

      if (result.status) {
        toast.success("Designation deleted successfully!");
        setUserDetails((prev) => ({
          ...prev,
          designation: (prev.designation || []).filter(
            (item) => item.UserDesignationId !== selectedId,
          ),
        }));
      }
    } catch (error) {
      toast.warn("Something went wrong!" + error);
    }
  };
  const getProfessional = (type) => {
    if (type === "Others") {
      setOtherType(false);
      setOtherTypeStyle({
        backgroundColor: "",
        color: "#6b7280",
        cursor: "",
      });
    } else {
      setOtherTypeStyle({
        backgroundColor: "#f3f4f6",
        color: "#6b7280",
        cursor: "not-allowed",
      });
      setOtherType(true);
    }
  };
  const onUserInvite = (id) => {
    setLoading(true);
    let urlPath = "GetUserDetails/" + id;
    fetch(url.AUTH_URL + urlPath, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((responseData) => {
        if (responseData.status == true) {
          var user = responseData.response.user;

          setUserDetails({
            Fname: user.firstName || "",
            lname: user.lastName || "",
            resident_type: user.resident_type,
            email: user.email,
            mobile: user.mobileNo,
            countryCode: user.countryCode,
            vufId: user.vufId,
            country: user.country,
            state: user.state,
            city: user.city,
            joinedServices: user.joinedServices.join(", "),
            gender: user.gender,
            otherProfession: user.otherProfession,
            profession: user.profession,
            street_address: user.street_address,
            address2:
              user.resident_type === "NRI"
                ? user.city + ", " + user.state + ", " + user.country
                : user.city +
                ", " +
                user.district +
                ", " +
                user.state +
                ", " +
                user.country,
            role: user.role,
            designation: user.userDesignation,
            bloodGroup: user.bloodgroup,
            dob: normalizeDob(user.dob),
            area: user.area && user.area !== undefined ? user.area : "",
            pincode: user.pincode,
            profilePic:
              user.profilePicture && user.profilePicture !== undefined
                ? `${url.USER_PROFILE_URL}` + user.profilePicture
                : "",
          });
          const categoryIds = user.userDesignation.map((item) => item.category);
          const departmentIds = user.userDesignation.map(
            (item) => item.department,
          );
          const designationIds = user.userDesignation.map(
            (item) => item.designation,
          );
          setSelectCategory(
            categoryOptions.filter((opt) => categoryIds.includes(opt.value)),
          );

          setSelectDepartment(
            departmentOptions.filter((opt) =>
              departmentIds.includes(opt.value),
            ),
          );

          setSelectDesignation(
            designationOptions.filter((opt) =>
              designationIds.includes(opt.value),
            ),
          );
        } else {
          alert(
            "Oops! \n\n Something went wrong, Please try again after sometime.",
          );
        }
      })
      .catch((error) => { })
      .finally((final) => {
        // this.recaptchaRef.current.reset();
        // return this.setState({ isInvitingUser: false })
        setLoading(false);
      });
  };

  function onChangePostcode(pincode) {
    if (!pincode) {
      clearAddressFields();
      return;
    }
    let urlPath;
    if (locationType.label == "NRI") {
      urlPath = `auth/nriPostalCode/us/${pincode}`;
    } else {
      urlPath = `auth/PostalCode/${pincode}`;
    }
    setLoadingText(true);
    setDisabled(true);
    fetch(`${url.VUF_APP_API}${urlPath}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (locationType.label == "NRI") {
          if (data.status) {
            const responseData = data.response;
            setLoadingText(false);
            setDisabled(false);
            countryListWithCode();
            const areaList = responseData.map((data) => ({
              label: data.city,
              id: data.city,
              Code: data.postalCode,
            }));
            const fullAddress = [
              responseData[0].city,
              responseData[0].state,
              responseData[0].country,
            ]
              .filter(Boolean)
              .join(", ");

            setUserDetails((prev) => ({
              ...prev,
              address2: fullAddress,
              city: responseData[0].city,
              state: responseData[0].state,
              country: responseData[0].country,
            }));
            setSelectedCountry(responseData[0].country);
            // setSelectedCountry(firstOffice.country || "");
            // setSelectedState(firstOffice.State || "");
            // setSelectedDistrict(firstOffice.District || "");
            // setSelectedCity(firstOffice.Block || "");
            setAreas(areaList);
          }
        } else {
          if (data?.status) {
            const postOffices = data.response?.[0]?.PostOffice || [];

            if (postOffices.length > 0) {
              const firstOffice = postOffices[0];

              const fullAddress = [
                firstOffice.Block,
                firstOffice.District,
                firstOffice.State,
                firstOffice.Country,
              ]
                .filter(Boolean)
                .join(", ");

              setUserDetails((prev) => ({
                ...prev,
                address2: fullAddress,
                city: firstOffice.Block,
                state: firstOffice.State,
                district: firstOffice.District,
                country: firstOffice.Country,
              }));

              // If you still want separate state variables for other uses
              setSelectedCountry(firstOffice.Country || "");
              setSelectedState(firstOffice.State || "");
              setSelectedDistrict(firstOffice.District || "");
              setSelectedCity(firstOffice.Block || "");

              const areasList = postOffices.map((office) => ({
                label: office.Name,
                id: office.Name,
                Code: office.Name,
              }));
              setAreas(areasList);
              setLoadingText(false);
              setDisabled(false);
              setErrors((prev) => ({ ...prev, pincode: "" }));
            } else {
              handleInvalidPincode();
              setLoadingText(false);
              setDisabled(true);
            }
          } else {
            setLoadingText(false);
            setDisabled(true);
            handleInvalidPincode();
          }
        }
      })
      .catch((error) => {
        console.error("Pincode fetch error:", error);
        toast.warn("Something went wrong, please try again later.");
      });
  }
  // console.log(userDetails)
  useEffect(() => {
    if (id) {
      onUserInvite(id);
      onGetCategoryList();
      setCountryDropDown(true);
      onGetCategory();
      onGetService();
      // if (userDetails.role === "ORGANIZATION") {
      // }
    }
  }, [id]);

  function clearAddressFields() {
    setSelectedCountry("");
    setSelectedState("");
    setSelectedDistrict("");
    setSelectedCity("");
    setarea("");
    setAreas([]);
  }

  function handleInvalidPincode() {
    clearAddressFields();
    toast.error("Please enter correct pincode.");
  }

  function VUFIDFormat(vufId) {
    if (!vufId) return "";
    const groups = [];
    groups.push(vufId.slice(0, 4));
    if (vufId.length > 4) groups.push(vufId.slice(4, 8));
    if (vufId.length > 8) groups.push(vufId.slice(8, 12));
    return groups.filter(Boolean).join("-");
  }

  function onGetCategoryList() {
    let urlPath = "getCategory";
    setLoading(true);
    fetch(url.AUTH_URL + urlPath, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json()) // parse JSON here
      .then((responseData) => {
        if (responseData.status) {
          var data = responseData.data;

          let category = [];
          category.push({ label: "--Select--", value: "" });
          data.map((c) => {
            category.push({ label: c.name, value: c._id });
          });

          const cate = [{ options: category }];
          setCategoryOptions(cate);
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
        // Optional cleanup
      });
  }
  function onGetDepartmentList(id) {
    let urlPath = "getDepartment/" + id;

    fetch(url.AUTH_URL + urlPath, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json()) // parse JSON here
      .then((responseData) => {
        if (responseData.status) {
          var data = responseData.data;

          let department = [];
          department.push({ label: "--Select--", value: "" });

          data.map((d) => {
            department.push({ label: d.name, value: d._id });
          });

          const departments = [{ options: department }];
          setDepartmentOptions(departments);
        }
      })
      .catch((error) => {
        console.log(error);

        console.error("Fetch error:", error);
      })
      .finally(() => {
        // Optional cleanup
      });
  }
  function onGetDesignationList(id) {
    let urlPath = "getDesignation/" + id;

    fetch(url.AUTH_URL + urlPath, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json()) // parse JSON here
      .then((responseData) => {
        if (responseData.status) {
          var data = responseData.data;

          let designation = [];
          designation.push({ label: "--Select--", value: "" });
          data.map((c) => {
            designation.push({ label: c.name, value: c._id });
          });

          const designations = [{ options: designation }];
          setDesignationOptions(designations);
        }
      })
      .catch((error) => {
        console.log(error);
        console.error("Fetch error:", error);
      })
      .finally(() => {
        // Optional cleanup
      });
  }
  function onGetCategory() {
    let urlPath = "category/get-category";
    setLoading(true);
    fetch(url.VUF_APP_API + urlPath, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json()) // parse JSON here
      .then((responseData) => {
        if (responseData.status) {
          var data = responseData.response;

          let benefitsCategory = [];
          benefitsCategory.push({ label: "--Select--", value: "" });
          data.map((c) => {
            benefitsCategory.push({ label: c.name, value: c._id });
          });

          const cate = [{ options: benefitsCategory }];
          setBenefitsCategoryOptions(cate);
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
        // Optional cleanup
      });
  }
  //console.log(benefitsCategoryOptions)
  function onGetService() {
    let urlPath = "service/get-service";
    setLoading(true);
    fetch(url.VUF_APP_API + urlPath, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json()) // parse JSON here
      .then((responseData) => {
        if (responseData.status) {
          var data = responseData.response;

          let benefitsService = [];
          benefitsService.push({ label: "--Select--", value: "" });
          data.map((s) => {
            benefitsService.push({ label: s.serviceName, value: s._id });
          });

          const service = [{ options: benefitsService }];
          setServiceOptions(service);
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
        // Optional cleanup
      });
  }
  const handlePhotoChange = async (e, id) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      setPreviewImage(reader.result);
    };
    reader.readAsDataURL(file);

    // Create FormData to send image
    const formData = new FormData();
    formData.append("profilePicture", file);
    formData.append("userId", id);

    try {
      setLoading(true);
      const res = await fetch(`${url.AUTH_URL}userprofileChange/${id}`, {
        method: "PUT",
        body: formData,
      });

      const result = await res.json();
      if (res.ok) {
        setLoading(false);
        toast.success("Profile photo updated successfully!");
        onUserInvite(id);
      } else {
        alert(result.message || "Failed to update profile photo.");
      }
    } catch (error) {
      console.error("Upload error:", error);
      alert("Something went wrong.");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let payload, dataMethod, requestUrl;

    // Role condition removed intentionally: apply designation flow for all users.
    // if (userDetails.role === "MEMBER") {
    payload = {
      departmentId: SelectedDepartment.value,
      designationId: SelectedDesignation.value,
      categoryId: SelectedCategory.value,
      userId: selectedId,
    };
    requestUrl = url.AUTH_URL + `/updateUserDesignation/${selectedId}`;
    dataMethod = "PUT";
    // } else {
    //   Benefits flow disabled by requirement.
    // }

    try {
      const response = await fetch(requestUrl, {
        method: dataMethod,
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();
      if (result.status) {
        toast.success("User Designation Updated Successfully!");
        setShowModal(false);
        setSelectCategory("");
      } else {
        toast.error("Update failed.");
      }
    } catch (error) {
      console.error("Update error:", error);
      toast.warn("Something went wrong!");
    }
  };
  return (
    <React.Fragment>
      {isLoading ? (
        <Spinners />
      ) : (
        <Row>
          <Col xl="12">
            <Card>
              <CardHeader>
                <Row>
                  <Col md="9">
                    <CardTitle className="h4 mb-0">User Edit</CardTitle>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <div
                  className="container"
                  style={{ maxWidth: "100%", margin: "0px" }}
                >
                  <div className="row">
                    <div className="col-md-3 mt-4 d-flex flex-column align-items-center justify-content-start">
                      {userDetails?.profilePic || previewImage ? (
                        <img
                          src={userDetails?.profilePic}
                          alt="Profile"
                          className="rounded"
                          width="170"
                          height="170"
                        />
                      ) : (
                        <div
                          className="bg-secondary text-white rounded d-flex align-items-center justify-content-center"
                          style={{
                            width: "170px",
                            height: "170px",
                            fontSize: "48px",
                          }}
                        >
                          {`${userDetails.Fname?.charAt(0) || ""}${userDetails.lname?.charAt(0) || ""}`.toUpperCase()}
                        </div>
                      )}
                      <h5 className="mt-3">
                        {userDetails.Fname} {userDetails.lname}
                      </h5>
                      <label
                        htmlFor="profilePic"
                        className="btn btn-sm btn-outline-primary"
                      >
                        Change Photo
                      </label>
                      <input
                        type="file"
                        id="profilePic"
                        onChange={(e) => handlePhotoChange(e, id)}
                        accept="image/*"
                        style={{ display: "none" }}
                      />
                    </div>
                    <div className="col-md-9">
                      <form
                        onSubmit={(e) => {
                          e.preventDefault();
                          handleUpdateDetails(id);
                        }}
                      >
                        <div className="row">
                          <div className="col-md-4">
                            <div className="form-group">
                              <label>First Name:</label>
                              <input
                                type="text"
                                className="form-control"
                                value={userDetails.Fname}
                                onChange={(e) =>
                                  setUserDetails({
                                    ...userDetails,
                                    Fname: e.target.value,
                                  })
                                }
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label>Last Name:</label>
                              <input
                                type="text"
                                className="form-control"
                                value={userDetails.lname}
                                onChange={(e) =>
                                  setUserDetails({
                                    ...userDetails,
                                    lname: e.target.value,
                                  })
                                }
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label>Resident Type</label>
                              <select
                                className="form-select"
                                value={userDetails.resident_type}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  setUserDetails((prev) => ({
                                    ...prev,
                                    resident_type: value,
                                  }));
                                  setLocationType(value);
                                  ChangeLocation(value);
                                  countryListWithCode(value);
                                }}
                              >
                                <option value="">Select Resident Type</option>
                                <option value="Indian Resident">
                                  Indian Resident
                                </option>
                                <option value="NRI">NRI</option>
                              </select>
                            </div>
                          </div>
                          {userDetails.resident_type === "NRI" &&
                            countryDropdown && (
                              <div className="col-md-4">
                                <div className="form-group">
                                  <label>Country</label>
                                  <Select
                                    name="location_type"
                                    value={countryList.find(
                                      (item) =>
                                        item.label === userDetails.country,
                                    )}
                                    options={countryList}
                                    onChange={(selectedOption) => {
                                      //console.log(selectedOption)
                                      setCountryCode(selectedOption.code);
                                      setPhoneCode(selectedOption.pCode);
                                      setUserDetails({
                                        ...userDetails,
                                        country: selectedOption.value,
                                      });
                                    }}
                                  />
                                </div>
                              </div>
                            )}
                          <div className="col-md-4">
                            <div className="form-group">
                              <label>Email:</label>
                              <input
                                type="email"
                                className="form-control"
                                value={userDetails.email}
                                onChange={(e) =>
                                  setUserDetails({
                                    ...userDetails,
                                    email: e.target.value,
                                  })
                                }
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label>Mobile No.</label>
                              <div className="input-group">
                                {userDetails.resident_type &&
                                  userDetails.countryCode &&
                                  phoneCode && (
                                    <span className="input-group-text">
                                      {""}+{phoneCode}
                                    </span>
                                  )}
                                <Input
                                  // disabled="true"
                                  type="text"
                                  className="form-control"
                                  value={userDetails.mobile}
                                  onChange={(e) =>
                                    setUserDetails({
                                      ...userDetails,
                                      mobile: e.target.value,
                                    })
                                  }
                                // style={{
                                //   backgroundColor: "#f3f4f6",
                                //   color: "#6b7280",
                                //   cursor: "not-allowed",
                                // }}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label>Gender</label>
                              <select
                                value={userDetails.gender}
                                onChange={(e) =>
                                  setUserDetails({
                                    ...userDetails,
                                    gender: e.target.value,
                                  })
                                }
                                className="form-control select2-selection border-1 shadow-none"
                              >
                                <option value="">Select Gender</option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                              </select>
                              .
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-4">
                            <div className="form-group">
                              <label>Blood Group</label>
                              <select
                                className="form-control select2-selection border-1 shadow-none"
                                id="blood-group"
                                name="blood-group"
                                value={userDetails.bloodGroup}
                                onChange={(e) =>
                                  setUserDetails({
                                    ...userDetails,
                                    bloodGroup: e.target.value,
                                  })
                                }
                              >
                                <option value="">
                                  Please choose an option
                                </option>
                                <option value="A+">A Positive (A+)</option>
                                <option value="A-">A Negative (A-)</option>
                                <option value="B+">B Positive (B+)</option>
                                <option value="B-">B Negative (B-)</option>
                                <option value="AB+">AB Positive (AB+)</option>
                                <option value="AB-">AB Negative (AB-)</option>
                                <option value="O+">O Positive (O+)</option>
                                <option value="O-">O Negative (O-)</option>
                                <option value=" ">Not Available</option>
                              </select>
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-group">
                              <label>Join Services:</label>
                              <input
                                disabled=""
                                type="text"
                                className="form-control"
                                value={userDetails.joinedServices}
                                style={{
                                  backgroundColor: "#f3f4f6",
                                  color: "#6b7280",
                                  cursor: "not-allowed",
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label>VUF ID:</label>
                              <input
                                disabled=""
                                type="text"
                                className="form-control"
                                value={VUFIDFormat(userDetails.vufId)}
                                style={{
                                  backgroundColor: "#f3f4f6",
                                  color: "#6b7280",
                                  cursor: "not-allowed",
                                }}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-4">
                            <div className="form-group">
                              <label>Date of Birth:</label>
                              {/* <Flatpickr
                                key={userDetails.dob ? userDetails.dob.toString() : "empty"}
                                value={userDetails.dob || null}
                                placeholder="Select Date"
                                options={{
                                  dateFormat: "Y-m-d",
                                  maxDate: "today",
                                }}
                                onChange={(selectedDates) =>
                                  setUserDetails({
                                    ...userDetails,
                                    dob: selectedDates[0] || null,
                                  })
                                }
                                ref={flatpickrRef}
                              /> */}
                              <Flatpickr
                                value={userDetails.dob instanceof Date ? userDetails.dob : null}
                                options={{
                                  dateFormat: "Y-m-d",
                                  maxDate: "today",
                                }}
                                onChange={(selectedDates) =>
                                  setUserDetails({
                                    ...userDetails,
                                    dob: selectedDates[0] || null,
                                  })
                                }
                              />
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-group">
                              <label className="form-label">Role:</label>
                              <input
                                disabled=""
                                type="text"
                                className="form-control"
                                value={userDetails.role}
                                style={{
                                  backgroundColor: "#f3f4f6",
                                  color: "#6b7280",
                                  cursor: "not-allowed",
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label>Profession:</label>
                              <select
                                className="form-select select2-selection"
                                placeholder="Select Type"
                                value={userDetails.profession || ""}
                                onChange={(e) => {
                                  getProfessional(e.target.value);
                                  setUserDetails({
                                    ...userDetails,
                                    profession: e.target.value,
                                  });
                                }}
                              >
                                <option value="">Select Profession</option>
                                {ProfessionObj.map((item, index) => (
                                  <option key={index} value={item.value}>
                                    {item.label}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-4">
                            <div className="form-group">
                              <label>Please specify:</label>
                              <Input
                                type="text"
                                disabled={OtherType}
                                className="form-control form-control-solid"
                                value={userDetails.otherProfession || ""}
                                style={OtherTypeStyle}
                                onChange={(e) =>
                                  setUserDetails({
                                    ...userDetails,
                                    otherProfession: e.target.value,
                                  })
                                }
                                placeholder="Enter your profession"
                              />
                            </div>
                          </div>
                          {!postcodeDropdown &&
                            userDetails.resident_type === "Indian Resident" ? (
                            <>
                              <div className="col-md-4">
                                <label className="form-label">
                                  <b>Pin code:</b>
                                </label>
                                <div className="form-group input-group">
                                  <Input
                                    type="text"
                                    className="form-control form-control-solid"
                                    pattern="^[0-9]{6}$"
                                    inputMode="numeric"
                                    onChange={(event) => {
                                      const onlyDigits =
                                        event.target.value.replace(/\D/g, "");
                                      setUserDetails((prev) => ({
                                        ...prev,
                                        pincode: onlyDigits.slice(0, 6),
                                      }));
                                    }}
                                    placeholder="Pincode"
                                    value={userDetails.pincode}
                                  />
                                  <button
                                    type="button"
                                    style={{
                                      outline: "none",
                                      transform: "none",
                                      boxShadow: "none",
                                    }}
                                    className="btn btn-outline-info"
                                    onClick={() => {
                                      setShowArea(true);
                                      onChangePostcode(userDetails.pincode);
                                    }}
                                  >
                                    Fetch Area
                                  </button>
                                </div>
                              </div>
                            </>
                          ) : (
                            <>
                              <div className="col-md-4">
                                <label className="form-label">
                                  <b>Post code (NRI)</b>
                                </label>
                                <div className="form-group input-group">
                                  <Input
                                    type="text"
                                    className="form-control form-control-solid"
                                    pattern="^\d{5}(-\d{4})?$"
                                    inputMode="numeric"
                                    onChange={(event) => {
                                      const onlyDigits =
                                        event.target.value.replace(/\D/g, "");
                                      setUserDetails((prev) => ({
                                        ...prev,
                                        pincode: onlyDigits.slice(0, 6),
                                      }));
                                    }}
                                    placeholder="Enter post code"
                                    value={userDetails.pincode}
                                  />
                                  <button
                                    type="button"
                                    style={{
                                      outline: "none",
                                      transform: "none",
                                      boxShadow: "none",
                                    }}
                                    className="btn btn-outline-info"
                                    onClick={() => {
                                      setShowArea(true);
                                      onChangePostcode(userDetails.pincode);
                                    }}
                                  >
                                    Fetch Area
                                  </button>
                                </div>
                              </div>
                            </>
                          )}

                          {showArea ? (
                            <div className="col-md-4">
                              <div className="form-group">
                                <label>Area:</label>
                                <select
                                  disabled={disabled}
                                  onChange={(event) =>
                                    setUserDetails((prev) => ({
                                      ...prev,
                                      area: event.target.value,
                                    }))
                                  }
                                  className="form-select"
                                  value={userDetails.area || ""}
                                >
                                  <option value="">Select Area</option>
                                  {areas.map((area) => (
                                    <option key={area.value} value={area.value}>
                                      {area.label}
                                    </option>
                                  ))}
                                </select>
                                {LoadingText ? (
                                  <span className="text-muted">
                                    Please wait… Loading
                                  </span>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          ) : (
                            <div className="col-md-4">
                              <div className="form-group">
                                <label>Area: </label>
                                <Input
                                  className="form-control form-control-solid"
                                  value={userDetails.area}
                                  readOnly="true"
                                  style={{
                                    backgroundColor: "#f3f4f6",
                                    color: "#6b7280",
                                    cursor: "not-allowed",
                                  }}
                                  onChange={(event) =>
                                    setUserDetails((prev) => ({
                                      ...prev,
                                      area: event.target.value,
                                    }))
                                  }
                                />
                              </div>
                            </div>
                          )}
                        </div>
                        <div className="row">
                          <div className="col-md-4">
                            <div className="form-group">
                              {userDetails.resident_type === "NRI" ? (
                                <label className="form-label">
                                  City, State, Country:
                                </label>
                              ) : (
                                <label className="form-label">
                                  City, District, State, Country:
                                </label>
                              )}
                              <Input
                                readOnly="true"
                                type="text"
                                className="form-control"
                                value={userDetails.address2}
                                style={{
                                  backgroundColor: "#f3f4f6",
                                  color: "#6b7280",
                                  cursor: "not-allowed",
                                }}
                                onChange={(event) =>
                                  setUserDetails((prev) => ({
                                    ...prev,
                                    address2: event.target.value,
                                  }))
                                }
                              />
                            </div>
                          </div>
                          <div className="col-md-8">
                            <div className="form-group">
                              <label>Address</label>
                              <Input
                                value={userDetails.street_address || ""}
                                onChange={(event) =>
                                  setUserDetails((prev) => ({
                                    ...prev,
                                    street_address: event.target.value,
                                  }))
                                }
                              ></Input>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            <div className="col-md-4">
                              <button
                                type="submit"
                                style={{
                                  outline: "none",
                                  transform: "none",
                                  boxShadow: "none",
                                }}
                                className="btn btn-outline-success me-3"
                              >
                                <span className="fa fa-edit me-2"></span>Update
                              </button>
                              <a
                                className="btn btn-outline-primary"
                                href="/UserList"
                              >
                                <span className="menu-text fa fa-arrow-left me-2"></span>
                                Back to List
                              </a>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </CardBody>
              {/* userDetails.role check removed: designation modal applies to all users */}
              {true ? (
                <div className="row">
                  <Modal
                    size="m"
                    centered
                    show={showModal}
                    backdrop="static"
                    keyboard={false}
                    onHide={() => setShowModal(false)}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>Update Designation</Modal.Title>
                    </Modal.Header>
                    <form onSubmit={handleSubmit}>
                      <Modal.Body>
                        <div className="row">
                          <div className="col-md-12">
                            <div className="form-group">
                              <label>Category</label>
                              <Select
                                classNamePrefix="select2-selection"
                                value={SelectedCategory}
                                options={categoryOptions}
                                onChange={(e) => {
                                  setSelectCategory(e);
                                  onGetDepartmentList(e.value);
                                  onGetDesignationList(e.value);
                                }}
                              ></Select>
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group">
                              <label>Designation:</label>
                              <Select
                                classNamePrefix="select2-selection"
                                value={SelectedDesignation}
                                onChange={(e) => {
                                  setSelectDesignation(e);
                                }}
                                options={designationOptions}
                              ></Select>
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group">
                              <label>Department:</label>
                              <Select
                                classNamePrefix="select2-selection"
                                value={SelectedDepartment}
                                onChange={(e) => {
                                  setSelectDepartment(e);
                                  onGetDesignationList(e.value);
                                }}
                                options={departmentOptions}
                              ></Select>
                            </div>
                          </div>
                        </div>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button variant="primary" type="submit">
                          Save
                        </Button>
                        <Button
                          variant="secondary"
                          onClick={() => setShowModal(false)}
                        >
                          Close
                        </Button>
                      </Modal.Footer>
                    </form>
                  </Modal>
                </div>
              ) : (
                <div className="row">
                  <Modal
                    size="m"
                    centered
                    show={showBenefitsModal}
                    backdrop="static"
                    keyboard={false}
                    onHide={() => setShowBenefitsModal(false)}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>Update Benefits</Modal.Title>
                    </Modal.Header>
                    <form onSubmit={handleSubmit}>
                      <Modal.Body>
                        <div className="row">
                          <div className="col-md-12">
                            <div className="form-group">
                              <label>Benefit Category</label>
                              <Select
                                classNamePrefix="select2-selection"
                                value={SelectedCategory}
                                options={benefitsCategoryOptions}
                                onChange={(e) => {
                                  setSelectCategory(e);
                                }}
                              ></Select>
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group">
                              <label>Service:</label>
                              <Select
                                classNamePrefix="select2-selection"
                                value={selectedService}
                                onChange={(e) => {
                                  setSelectService(e);
                                }}
                                options={serviceOptions}
                              ></Select>
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group">
                              <label>Discount:</label>
                              <Input
                                className="form-control"
                                type="number" // Ensures you're sending numeric strings/numbers
                                value={SelectedDiscount}
                                onChange={(e) => {
                                  const val = e.target.value;
                                  // Simple validation to ensure only positive numbers are entered
                                  if (val >= 0) {
                                    setSelectedDiscount(val);
                                  }
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button variant="primary" type="submit">
                          Save
                        </Button>
                        <Button
                          variant="secondary"
                          onClick={() => setShowBenefitsModal(false)}
                        >
                          Close
                        </Button>
                      </Modal.Footer>
                    </form>
                  </Modal>
                </div>
              )}
              <div className="row">
                <Modal
                  size="m"
                  centered
                  show={showModal}
                  backdrop="static"
                  keyboard={false}
                  onHide={() => setShowModal(false)}
                >
                  <Modal.Header closeButton>
                    <Modal.Title>Update Designation</Modal.Title>
                  </Modal.Header>
                  <form onSubmit={handleSubmit}>
                    <Modal.Body>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="form-group">
                            <label>Category</label>
                            <Select
                              classNamePrefix="select2-selection"
                              value={SelectedCategory}
                              options={categoryOptions}
                              onChange={(e) => {
                                setSelectCategory(e);
                                onGetDepartmentList(e.value);
                                onGetDesignationList(e.value);
                              }}
                            ></Select>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <label>Designation:</label>
                            <Select
                              classNamePrefix="select2-selection"
                              value={SelectedDesignation}
                              onChange={(e) => {
                                setSelectDesignation(e);
                              }}
                              options={designationOptions}
                            ></Select>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <label>Department:</label>
                            <Select
                              classNamePrefix="select2-selection"
                              value={SelectedDepartment}
                              onChange={(e) => {
                                setSelectDepartment(e);
                                onGetDesignationList(e.value);
                              }}
                              options={departmentOptions}
                            ></Select>
                          </div>
                        </div>
                      </div>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button variant="primary" type="submit">
                        Save
                      </Button>
                      <Button
                        variant="secondary"
                        onClick={() => setShowModal(false)}
                      >
                        Close
                      </Button>
                    </Modal.Footer>
                  </form>
                </Modal>
              </div>
              <div className="row">
                <Modal
                  show={showDeleteModal}
                  onHide={() => setShowDeleteModal(false)}
                  centered
                >
                  <Modal.Header closeButton>
                    <Modal.Title>Confirm Delete</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    Are you sure you want to delete this item?
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      variant="secondary"
                      onClick={() => setShowDeleteModal(false)}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="danger"
                      onClick={handleUserDesignationDelete}
                    >
                      Yes, Delete
                    </Button>
                  </Modal.Footer>
                </Modal>
              </div>
              <CardBody>
                {/* userDetails.role check removed: designation table applies to all users */}
                {true ? (
                  <>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h4 className="mb-0">User Designation</h4>
                      <div className="d-flex gap-2">
                        <button
                          className="btn btn-outline-primary"
                          style={{
                            outline: "none",
                            transform: "none",
                            boxShadow: "none",
                          }}
                          onClick={(e) => {
                            setShowModal(true);
                            setSelectedId(id);
                          }}
                        >
                          <span className="fa fa-plus me-2"></span>Update
                          Designation
                        </button>
                      </div>
                    </div>
                    <table className="table table-bordered table-striped shadow-sm">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Category</th>
                          <th>Designation</th>
                          <th>Department</th>
                          <th>Delete</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Array.isArray(userDetails.designation) &&
                          userDetails.designation.length > 0 &&
                          !userDetails.designation.every(
                            (obj) => Object.keys(obj).length === 0,
                          ) ? (
                          userDetails.designation.map((item, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{item.category || "--"}</td>
                              <td>{item.designation || "--"}</td>
                              <td>{item.department || "--"}</td>
                              <td>
                                <button
                                  className="btn btn-danger"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setSelectedId(item.UserDesignationId);
                                    setShowDeleteModal(true);
                                  }}
                                >
                                  <i className="fa fa-trash"></i>
                                </button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="5" className="text-center text-muted">
                              No Record Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </>
                ) : (
                  <>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h4 className="mb-0">Benefits Listing</h4>
                      <div className="d-flex gap-2">
                        <button
                          className="btn btn-outline-primary"
                          style={{
                            outline: "none",
                            transform: "none",
                            boxShadow: "none",
                          }}
                          onClick={(e) => {
                            setShowBenefitsModal(true);
                            setSelectedBenefitId(id);
                          }}
                        >
                          <span className="fa fa-plus me-2"></span>Update
                          Benefits
                        </button>
                      </div>
                    </div>
                    <table className="table table-bordered table-striped shadow-sm">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Category</th>
                          <th>Service</th>
                          <th>Discount</th>
                          <th>Delete</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Array.isArray(userDetails.designation) &&
                          userDetails.designation.length > 0 &&
                          !userDetails.designation.every(
                            (obj) => Object.keys(obj).length === 0,
                          ) ? (
                          userDetails.designation.map((item, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{item.category || "--"}</td>
                              <td>{item.designation || "--"}</td>
                              <td>{item.department || "--"}</td>
                              <td>
                                <button
                                  className="btn btn-danger"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setSelectedId(item.UserDesignationId);
                                    setShowDeleteModal(true);
                                  }}
                                >
                                  <i className="fa fa-trash"></i>
                                </button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="5" className="text-center text-muted">
                              No Record Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      )}
    </React.Fragment>
  );
};

export default connect(null, { setBreadcrumbItems })(UsersEdit);
